exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media all and (min-width: 480px) {\n    .Signup {\n      padding: 60px 0;\n    }\n\n    .Signup form {\n      margin: 0 auto;\n      max-width: 320px;\n    }\n  }\n\n  \n", ""]);

